import moment from 'moment';

const promotionHelper = {};

promotionHelper.prepForPush = (data, coinValue=false) => {
  if (data === false) return false;
  if (coinValue) data.point_value = coinValue;
  data.earn_value = data.point_value;
  data.start_date = moment(data.start_date);
  data.end_date = moment(data.end_date);
  data.method = 'earn';
  data.is_active = true;
  return data;
}

promotionHelper.prepCampaignForPush = (data) => {
  if (data === false) return false;
  data.earn_value = 0;
  data.start_date = moment(data.start_date);
  data.end_date = moment(data.end_date);
  data.method = 'campaign-accept';
  data.is_active = true;
  return data;
}

promotionHelper.prepClaimForPush = (data) => {
  if (data === false) return false;
  data.earn_value = 0;
  data.start_date = moment(data.start_date);
  data.end_date = moment(data.end_date);
  data.method = 'campaign-claim';
  data.is_active = true;
  return data;
}

promotionHelper.prepAcceptForPush = (data) => {
  if (data === false) return false;
  data.earn_value = 0;
  data.start_date = moment(data.start_date);
  data.end_date = moment(data.end_date);
  data.method = 'campaign-accept';
  data.is_active = true;
  return data;
}

export default promotionHelper



/** WEBPACK FOOTER **
 ** ./src/helpers/promotions/buildValues.js
 **/